import React from "react";
import { ModalContainer, MODAL_IDS } from "@wtc/ui";
import { LinkContactModal } from "./LinkContactModal";
import type { LinkContactModalData } from "@/lib/modals/data/modal-data-types";

/**
 * Wrapper component for LinkContactModal that integrates with the global modal stack
 *
 * This component:
 * 1. Uses ModalContainer to manage modal state and data
 * 2. Extracts companyId and companyName from modal data
 * 3. Passes them to LinkContactModal
 * 4. Provides isOpen and onClose callbacks
 *
 * The modal ID is registered in MODAL_IDS.companies.linkContact
 */
export const LinkContactModalWrapper: React.FC = () => {
  return (
    <ModalContainer<LinkContactModalData> modalId={MODAL_IDS.companies.linkContact}>
      {({ isOpen, data, onClose }) => (
        <LinkContactModal
          companyId={data?.companyId || ""}
          companyName={data?.companyName || ""}
          isOpen={isOpen}
          onClose={onClose}
        />
      )}
    </ModalContainer>
  );
};
